import { Label } from 'reactstrap';
import '../assets/style/SearchBox.css';
import React from 'react';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
interface IKDatePickerProps {
  label?: string;
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  onChange: (date: Date) => void;
  yearMonth?: boolean;
  format?: string;
  disabled?: boolean;
  required?: boolean;
  removebackgroundColor?: boolean;
  allowTyping?: boolean;
}

const KDatePicker: React.FunctionComponent<IKDatePickerProps> = ({
  label,
  value,
  minDate,
  maxDate,
  onChange,
  yearMonth,
  format,
  disabled = false,
  required = false,
  removebackgroundColor = false,
  allowTyping = false,
}) => {
  return (
    <div className="mb-3">
      <Label
        className={
          disabled && (required || removebackgroundColor)
            ? 'mb-1 text-start'
            : required || removebackgroundColor
              ? 'mb-1 text-start search-label-normal'
              : 'mb-1 text-start search-label'
        }
        style={
          disabled
            ? {
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }
            : undefined
        }
      >
        {label}
        {required ? <span style={{ color: 'red' }}>*</span> : null}
      </Label>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DemoContainer components={['DatePicker']}>
          <DatePicker
            views={yearMonth ? ['year', 'month'] : undefined}
            minDate={minDate ? moment(minDate) : undefined}
            maxDate={maxDate ? moment(maxDate) : undefined}
            disabled={disabled}
            className="date-picker"
            value={value ? moment(value, format ?? 'DD-MM-YYYY') : null}
            format={format ?? 'DD-MM-YYYY'}
            slotProps={
              !allowTyping && (required || removebackgroundColor)
                ? {
                    textField: {
                      inputProps: {
                        readOnly: true,
                      },
                    },
                  }
                : undefined
            }
            onChange={(newValue) => {
              onChange(newValue ? newValue.toDate() : moment().toDate());
            }}
            sx={
              required || removebackgroundColor
                ? {
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '& fieldset': {
                        border: '1px solid #ced4da',
                        borderRadius: '5px',
                      },
                      '&:hover:not(.Mui-disabled) fieldset': {
                        border: '1px solid #0b67c3',
                      },
                      '&.Mui-focused fieldset': {
                        border: '1px solid #0b67c3',
                      },
                      '&.Mui-disabled fieldset': {
                        border: '1px solid #ced4da !important',
                      },
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor: 'transparent',
                    },
                  }
                : {
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        border: 'none',
                        borderColor: 'transparent',
                        borderRadius: '0px !important',
                      },
                      '&:hover fieldset': {
                        borderRadius: '5px !important',
                        border: '1px solid transparent !important',
                      },
                      '&.Mui-focused fieldset': {
                        borderRadius: '5px !important',
                        border: '1px solid #0b67c3 !important',
                      },
                    },
                  }
            }
          ></DatePicker>
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
};

export default KDatePicker;
